import { convertTimeUnit } from '@ad-scripts/presentation/components/common/input_with_time_convert_field';
import { get } from 'lodash';
import { useContext } from 'react';

import RoutingGroup, { DEFAULT_SLA_SECONDS } from 'src/models/RoutingGroup/RoutingGroup';
import FormContext from 'src/presentation/contexts/FormContext';
import { TimeUnits } from 'src/presentation/components/pages/shared/MinutesInputField';

export default function useDefaultSlaMinutes({ baseAttr, inboxesMap }) {
  const { workingState } = useContext(FormContext);

  const attr = baseAttr ? `${baseAttr}.` : '';

  const routingGroupId: string = get(workingState, `${attr}routingGroupId`, '');
  const inbox = inboxesMap[routingGroupId] as RoutingGroup;

  return convertTimeUnit(TimeUnits.Seconds, TimeUnits.Minutes, inbox?.slaSeconds || DEFAULT_SLA_SECONDS, true);
}
